import type { FilterableTaxon, PageType } from '@/types/models'
import { isNonEmptyString } from '@/utils/checks'
import type { PrimaryFocus } from '../primaryFocus/constant'
import { isLocationPageType } from '../useCases/pageTypeCheck'

export const filterTaxonomyForTerms = ({
  filterableTaxonomies,
  primaryFocus,
  term,
  pageType
}: {
  filterableTaxonomies: FilterableTaxon[]
  primaryFocus?: PrimaryFocus
  pageType: PageType
  term?: string
}): string[] => {
  if (isLocationPageType(pageType)) {
    return filterableTaxonomies
      .filter(({ node }) => node.primaryFocus === primaryFocus)
      .map(({ node }) => node.title)
  }
  if (!isNonEmptyString(term)) {
    return []
  }

  return filterableTaxonomies
    .filter(({ node }: FilterableTaxon) => node.title === term)
    .map(({ node }) => node.title)
}
